// extracted by mini-css-extract-plugin
export const container = "cta-module--container--24rDz";
export const text = "cta-module--text--aDO_n";